import React from 'react';
import { View } from 'react-native-web';
import { TranslateText } from './translate-text';

const InnerBoxTitle = ({title, subtitle}:any) => {
    console.log(title,subtitle);
    return (
        <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center', width:'100%'}}>
            <TranslateText style={{ fontSize: 28, fontWeight: "700", marginVertical: 8, textAlign:'center'}}>
                {title}            
            </TranslateText>
            <TranslateText
                style={{
                fontSize: 20,
                paddingHorizontal: 20,
                marginVertical: 8,
                textAlign: "center",
                color: "#686868",
                }}
            >
                {subtitle}
            </TranslateText>
        </View>
    )
}

export default InnerBoxTitle